import { useEffect } from 'react';
import { useGetIdentity } from 'react-admin';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { B2bCampaignsShow } from '@sh4res/bo-common/components/B2bCampaigns/show/B2bCampaignsShow';
import { buildLink } from '@sh4res/bo-common/utils/build_link';
import { isBoExternal } from '@sh4res/bo-common/utils/env';

export const CampaignsShow = ({ id }: { id?: number }) => {
  const { data: identity } = useGetIdentity();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams<{ id?: string }>();
  const campaignId = id ?? (params.id ? Number(params.id) : undefined);

  const isAdminLevel3or4 =
    identity?.roles.includes('admin_level_4') || identity?.roles.includes('admin_level_3');

  // https://sh4res.atlassian.net/browse/BRAV-9538
  // Redirect to collective_operations if accessed directly
  const isDirectAccess = isBoExternal() && location.pathname.includes('/campaigns/');
  useEffect(() => {
    if (isDirectAccess && campaignId !== undefined) {
      const collectiveOperationId = `campaign_${campaignId}`;
      navigate(buildLink('collective_operations', 'show', collectiveOperationId), {
        replace: true,
      });
    }
  }, [isDirectAccess, campaignId, navigate]);

  return (
    <B2bCampaignsShow
      id={id}
      showFundRequestActions={isAdminLevel3or4}
      navigateTo={() => 'collective_operations'}
    />
  );
};
